import type {ValueOf} from '~/types/value-of'

export const generalParamType = {
  BLOCK: 'BLOCK',
  GAS: 'GAS',
  BURNT_FEE: 'BURNT_FEE',
  NORMAL_TRANSACTION: 'NORMAL_TRANSACTION',
  NORMAL_TRANSACTION_TOTAL_COUNT: 'NORMAL_TRANSACTION_TOTAL_COUNT',
  INTERNAL_TRANSACTION: 'INTERNAL_TRANSACTION',
  INTERNAL_TRANSACTION_TOTAL_COUNT: 'INTERNAL_TRANSACTION_TOTAL_COUNT',
  PENDING_TRANSACTION: 'PENDING_TRANSACTION',
  PENDING_TRANSACTION_TOTAL_COUNT: 'PENDING_TRANSACTION_TOTAL_COUNT',
  TOKEN: 'TOKEN',
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  DAILY_ACCOUNT: 'DAILY_ACCOUNT',
  ACCOUNT: 'ACCOUNT',
  BALANCE: 'BALANCE',
  ALL: 'ALL',
} as const
export type generalParamType = ValueOf<typeof generalParamType>;